import React, { memo } from 'react';
import { useTranslations } from 'js/hooks/i18n';

import * as Types from './types';

import style from './GameLiveOpenDate.scss';

export const GameLiveOpenDateBare: React.FC<Types.IGameLiveOpenDateProps> = ({ game, className = '' }) => {
    const translate = useTranslations();
    const { liveConfiguration } = game;

    if (!liveConfiguration?.isScheduled) {
        return null;
    }

    return (
        <div className={`${style.openDate} ${className} cms-games-grid-live-open-date`}>
            {liveConfiguration?.openingDateTime
                ? (
                    <>
                        <span className='cms-games-grid-game-live-open-date-starts-at'>{translate('playtech.mobile.system.games-grid.game.live.startsAt')}</span>
                        <span className='cms-games-grid-game-live-open-date-time'>{liveConfiguration.openingDateTime}</span>
                    </>
                )
                : <span className='cms-games-grid-game-live-open-date-starts-soon'>{translate('playtech.mobile.system.games-grid.game.live.startsSoon')}</span>
            }
        </div>
    );
};

export const GameLiveOpenDate = memo(GameLiveOpenDateBare);
